import { faArrowLeft, faArrowRight, faSearch, faRotateRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import Paginator from 'react-hooks-paginator'
import { Link } from 'react-router-dom'
import CardBook from '../../../global/card/CardBook/CardBook'
import CardSkeleton from '../../../global/card/CardSkeleton/CardSkeleton'
import { Tooltip } from 'bootstrap'
import { classLevel, subjectsByLevel, allSubjectsForDisplay } from '../../../../constants/filterBook'
import Spotlight from '../../../global/Spotlight/Spotlight'

const SectionCatalog = ({ hideSidebar = false, level, setLevelNonText, tag, setTagNonText, setLatestBook, setClass, searchTitle, checkActive, books, loading, skeletonCount, typeBook, typeCatalogue, setTypeBook, setLevel, setLesson, setPopularBook, onResetFilter, lessonFilter = [], classFilter = [] }) => {
    
    const pageLimit = 12;
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);

    // const [lists, setLists] = useState([])
    const [openSpotlight, setOpenSpotlight] = useState(false)

    // Tooltip configuration
    const message = [
        "Jenjang A atau Jenjang Pembaca Dini adalah jenjang pembaca yang baru kali pertama mengenal buku yang memerlukan Perancah (scaffolding) untuk mendampingi anak membaca.",
        "Jenjang B atau Jenjang Pembaca Awal adalah jenjang pembaca yang memerlukan Perancah (scaffolding) dan mampu membaca teks berupa kata/frasa dengan kombinasi bunyi huruf, klausa, dan kalimat sederhana. ",
        "Jenjang C atau Jenjang Pembaca Semenjana adalah jenjang pembaca yang mampu membaca teks secara lancar berbentuk paragraf dalam satu wacana.",
        "Jenjang D atau Jenjang Pembaca Madya adalah jenjang pembaca yang mampu memahami beragam teks dengan tingkat kesulitan menengah.",
        "Jenjang E atau Jenjang Pembaca Mahir adalah jenjang pembaca yang mampu membaca secara analitis dan kritis berbagai sumber bacaan untuk menyintesis pemikiran secara lebih baik. "
    ]
    
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })

    const subjects = allSubjectsForDisplay;

    // Set for pagination
    useEffect(() => {
        setCurrentData(books?.slice(offset, offset + pageLimit));
    }, [offset, books]);

    const scrollTop = () => {
        setTimeout(() => {
            document.getElementById('catalog').scrollIntoView()
        }, 0);
    }

    const selectOnlyThis = (e) => {
        let id = e.target.id;
        for (var i = 1; i <= 4; i++) {
            document.getElementById("check" + i).checked = false;
        }
        document.getElementById(id).checked = true;
    }

    const setFilter = (value) => {
        if (value === 'semua') {
            setPopularBook('');
            setLatestBook('');
        } else if (value === 'popular') {
            setPopularBook('getPopularCatalogue');
            setLatestBook('');
        } else if (value === 'latest') {
            setLatestBook('sort=desc');
            setPopularBook('');
        }
    }

    const titleSidebar = typeCatalogue === 'getPenggerakTextBooks' ? 'Buku Teks Kurikulum Merdeka' : typeCatalogue === 'getTextBooks' ? 'Buku Teks K13' : typeCatalogue === 'getRecommendationBooks' ? 'Buku Rekomendasi' : 'Buku Nonteks'

    const getFilteredClasses = () => {
        if (checkActive === 'level_sd') {
            // SD: kelas I - VI
            return classLevel.filter(item => ['I', 'II', 'III', 'IV', 'V', 'VI'].includes(item.label));
        } else if (checkActive === 'level_smp') {
            // SMP: kelas VII - IX
            return classLevel.filter(item => ['VII', 'VIII', 'IX'].includes(item.label));
        } else if (checkActive === 'level_sma') {
            // SMA: kelas X - XII
            return classLevel.filter(item => ['X', 'XI', 'XII'].includes(item.label));
        } else if (checkActive === 'level_smk') {
            // SMK: kelas X - XII
            return classLevel.filter(item => ['X', 'XI', 'XII'].includes(item.label));
        }
        return classLevel;
    }

    // Function untuk mendapatkan label jenjang
    const getLevelLabel = (level) => {
        const levelMap = {
            'level_paud': 'PAUD',
            'level_sd': 'SD/MI',
            'level_smp': 'SMP/MTS',
            'level_sma': 'SMA/MA',
            'level_smk': 'SMK/MAK',
            'level_diksus': 'PENDIDIKAN KHUSUS'
        };
        return levelMap[level] || level;
    }

    // Function untuk mendapatkan label tipe buku
    const getTypeBookLabel = (type) => {
        const typeMap = {
            'type_pdf': 'Buku PDF',
            'type_audio': 'Buku Audio',
            'type_interactive': 'Buku Interaktif'
        };
        return typeMap[type] || type;
    }

    // Function untuk membuat deskripsi filter aktif
    const getFilterDescription = () => {
        let parts = [];
        
        // Tambah tipe buku jika bukan PDF
        if (typeBook && typeBook !== 'type_pdf') {
            parts.push(getTypeBookLabel(typeBook));
        }
        
        // Tambah jenjang
        if (checkActive) {
            parts.push(`Jenjang ${getLevelLabel(checkActive)}`);
        }

        // Tambah kelas jika ada
        if (classFilter && classFilter.length > 0) {
            const classLabels = classFilter.map(code => {
                const classItem = classLevel.find(item => item.code === code);
                return classItem?.label || code;
            }).join(', ');
            parts.push(`Kelas ${classLabels}`);
        }

        // Tambah mata pelajaran jika ada
        if (lessonFilter && lessonFilter.length > 0) {
            const lessonLabels = lessonFilter.map(slug => {
                const slugWithoutPrefix = slug.replace('subject_', '');
                const subjectItem = subjects.find(item => item.slug === slugWithoutPrefix);
                return subjectItem?.label || slug;
            }).join(', ');
            parts.push(`Mapel: ${lessonLabels}`);
        }
        
        return parts.join(' • ');
    }

    return (
        <section id="catalog">
            <div className="container px-3 py-5">
                <div className="row justify-content-center">
                    {!hideSidebar && (
                        <div className="col-lg-3">
                            <h4>{titleSidebar}</h4>
                            {
                                typeCatalogue === 'getNonTextBooks' || typeCatalogue === 'getRecommendationBooks'
                                    ? (
                                        <>
                                            <div className="card mt-3">
                                                <div className="card-header">
                                                    PILIH JENJANG
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_A')} checked={level === 'level_A' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeA" />
                                                        <label className="form-check-label" htmlFor="typeA">
                                                            Pembaca Dini A
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_B1')} checked={level === 'level_B1' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeB1" />
                                                        <label className="form-check-label" htmlFor="typeB1">
                                                            Pembaca Awal B1
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_B2')} checked={level === 'level_B2' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeB2" />
                                                        <label className="form-check-label" htmlFor="typeB2">
                                                            Pembaca Awal B2
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_B3')} checked={level === 'level_B3' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeB3" />
                                                        <label className="form-check-label" htmlFor="typeB3">
                                                            Pembaca Awal B3
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_C')} checked={level === 'level_C' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeC" />
                                                        <label className="form-check-label" htmlFor="typeC">
                                                            Pembaca Semenjana C
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_D')} checked={level === 'level_D' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeD1" />
                                                        <label className="form-check-label" htmlFor="typeD1">
                                                            Pembaca Madya D
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevelNonText('level_E')} checked={level === 'level_E' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" name="type_book" type="checkbox" id="typeE" />
                                                        <label className="form-check-label" htmlFor="typeE">
                                                            Pembaca Mahir E
                                                        </label>
                                                    </div>
                                                    <div className="mt-3">
                                                        <span className="link text-blue" style={{ cursor: 'pointer' }} data-bs-toggle="modal" data-bs-target="#descriptionModal">
                                                            Penjelasan Jenjang Buku
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mt-3">
                                                <div className="card-header">
                                                    PILIH TAG
                                                </div>
                                                <div className="card-body">
                                                    <a href="#" onClick={() => setTagNonText('Buku Model')} className={`me-2 mb-2 tag ${tag == 'Buku Model' && 'tag-active'}`}>#Buku Model</a>
                                                    <a href="#" onClick={() => setTagNonText('Buku KURASI')} className={`me-2 mb-2 tag ${tag == 'Buku KURASI' && 'tag-active'}`}>#Buku KURASI</a>
                                                    <a href="#" onClick={() => setTagNonText('transisi')} className={`me-2 mb-2 tag ${tag == 'transisi' && 'tag-active'}`}>#Transisi PAUD SD</a>
                                                    <a href="#" onClick={() => setTagNonText('Buku Pusbuk')} className={`me-2 mb-2 tag ${tag == 'Buku Pusbuk' && 'tag-active'}`}>#Buku Pusbuk</a>
                                                    <a href="#" onClick={() => setTagNonText('Buku Kerja Sama')} className={`me-2 mb-2 tag ${tag == 'Buku Kerja Sama' && 'tag-active'}`}>#Buku Kerja Sama</a>
                                                    <a href="#" onClick={() => setTagNonText('Buku Diksus')} className={`me-2 mb-2 tag ${tag == 'Buku Diksus' && 'tag-active'}`}>#Buku Diksus</a>
                                                    <a href="#" onClick={() => setTagNonText('English Version')} className={`me-2 mb-2 tag ${tag == 'English Version' && 'tag-active'}`}>#English Version</a>
                                                </div>
                                            </div>
                                        </>
                                    )
                                    : (
                                        <>
                                            <div className="card mt-3">
                                                <div className="card-header">
                                                    TIPE BUKU
                                                </div>
                                                <div className="card-body">
                                                    <div onChange={() => setTypeBook('type_pdf')} className="form-check">
                                                        <input className="form-check-input" checked={typeBook == 'type_pdf' && true} name="type_book" type="checkbox" id="typePDF" />
                                                        <label className="form-check-label" htmlFor="typePDF">
                                                            Buku PDF
                                                        </label>
                                                    </div>
                                                    <div onChange={() => setTypeBook('type_audio')} className="form-check">
                                                        <input className="form-check-input" checked={typeBook == 'type_audio' && true} name="type_book" type="checkbox" id="typeAudio" />
                                                        <label className="form-check-label" htmlFor="typeAudio">
                                                            Buku Audio
                                                        </label>
                                                    </div>
                                                    <div onChange={() => setTypeBook('type_interactive')} className="form-check">
                                                        <input className="form-check-input" checked={typeBook == 'type_interactive' && true} name="type_book" type="checkbox" id="typeInteractive" />
                                                        <label className="form-check-label" htmlFor="typeInteractive">
                                                            Buku Interaktif
                                                        </label>
                                                    </div>
                                                    <button 
                                                        onClick={() => {
                                                            // Reset semua checkbox
                                                            document.querySelectorAll('.col-lg-3 input[type="checkbox"]').forEach(checkbox => {
                                                                checkbox.checked = false;
                                                            });
                                                            // Reset dropdown/select
                                                            const selects = document.querySelectorAll('.col-lg-3 select');
                                                            selects.forEach(select => {
                                                                select.value = 'semua';
                                                            });
                                                            // Panggil parent reset function
                                                            onResetFilter?.();
                                                        }}
                                                        className="btn btn-sm btn-outline-secondary float-end"
                                                        title="Reset semua filter"
                                                    >
                                                        <FontAwesomeIcon icon={faRotateRight} className="me-1" />
                                                        Reset
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="card mt-3">
                                                <div className="card-header">
                                                    JENJANG
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-check">
                                                        <input onClick={() => setLevel('level_paud')} checked={checkActive == 'level_paud' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" type="checkbox" id="checkPAUD" />
                                                        <label className="form-check-label" htmlFor="checkPAUD">
                                                            PAUD
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevel('level_sd')} checked={checkActive == 'level_sd' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" type="checkbox" id="checkSD" />
                                                        <label className="form-check-label" htmlFor="checkSD">
                                                            SD/MI
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevel('level_smp')} checked={checkActive == 'level_smp' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" type="checkbox" id="checkSMP" />
                                                        <label className="form-check-label" htmlFor="checkSMP">
                                                            SMP/MTS
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevel('level_sma')} checked={checkActive == 'level_sma' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" type="checkbox" id="checkSMA" />
                                                        <label className="form-check-label" htmlFor="checkSMA">
                                                            SMA/MA
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input onClick={() => setLevel('level_smk')} checked={checkActive == 'level_smk' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" type="checkbox" id="checkSMK" />
                                                        <label className="form-check-label" htmlFor="checkSMK">
                                                            SMK/MAK
                                                        </label>
                                                    </div>
                                                    {
                                                        typeCatalogue === "getPenggerakTextBooks" && (
                                                            <div className="form-check">
                                                                <input onClick={() => setLevel('level_diksus')} checked={checkActive == 'level_diksus' ? true : false} onChange={(e) => selectOnlyThis(e)} className="form-check-input" type="checkbox" id="checkDIKSUS" />
                                                                <label className="form-check-label" htmlFor="checkDIKSUS">
                                                                    PENDIDIKAN KHUSUS
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {(checkActive === 'level_sd' || checkActive === 'level_smp' || checkActive === 'level_sma' || checkActive === 'level_smk') && (
                                                <div className="card mt-3">
                                                    <div className="card-header">
                                                        Kelas
                                                    </div>
                                                    <div className="card-body row overflow-auto">
                                                        {
                                                            getFilteredClasses().map((level, index) => (
                                                                <div className="col-6" key={index}>
                                                                    <div className="form-check">
                                                                        <input onChange={() => setClass(level.code)} className="form-check-input" type="checkbox" value="" id={level.label} />
                                                                        <label className="form-check-label" htmlFor={level.label}>
                                                                            {level.label}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            )}
                                            {checkActive !== 'level_paud' && checkActive !== 'level_diksus' && (
                                                <div className="card mt-3">
                                                    <div className="card-header">
                                                        MATA PELAJARAN
                                                    </div>
                                                <div className="card-body overflow-auto" style={{ height: '230px' }}>
                                                    {(() => {
                                                        const allowedSubjects = subjectsByLevel[checkActive] || [];
                                                        const filteredSubjects = subjects
                                                            .filter(lesson => allowedSubjects.includes(lesson.label))
                                                            .sort((a, b) => a.label.localeCompare(b.label));

                                                        if (filteredSubjects.length === 0) {
                                                            return <div className="text-muted">Menunggu pilihan filter...</div>;
                                                        }

                                                        return filteredSubjects.map((lesson, index) => (
                                                            <div className="form-check" key={index}>
                                                                <input
                                                                onChange={() => setLesson(lesson.code)}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value=""
                                                                id={lesson.label}
                                                                />
                                                                <label className="form-check-label" htmlFor={lesson.label}>
                                                                {lesson.label}
                                                                </label>
                                                            </div>
                                                        ));
                                                    })()}
                                                </div>
                                                </div>
                                            )}
                                        </>
                                    )
                            }
                        </div>
                    )}

                    <div className="col-lg-9">
                        <div className="d-flex justify-content-between align-items-center my-4">
                            <div>
                                {(checkActive || typeBook !== 'type_pdf' || (lessonFilter && lessonFilter.length > 0) || (classFilter && classFilter.length > 0)) && (
                                    <div className="text-muted small">
                                        Filter: {getFilterDescription()}
                                    </div>
                                )}
                            </div>
                            <div className="text-muted text-end">
                                Menampilkan {currentData?.length} buku ({currentData?.length} dari {books?.length} buku)
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-8 col-lg-8">
                                {/* Spotlight-style search trigger */}
                                <button
                                    type="button"
                                    onClick={() => setOpenSpotlight(true)}
                                    className="btn bg-white border w-100 d-flex align-items-center gap-2 py-2 shadow-sm"
                                    aria-label="Buka pencarian buku"
                                >
                                    <FontAwesomeIcon icon={faSearch} className="text-muted" />
                                    <span className="flex-grow-1 text-start text-muted">Cari buku disini</span>
                                    <span className="search-cta">Cari</span>
                                </button>
                            </div>
                            <div className="col-4 col-lg-4 my-auto text-end fw-bold">
                                <span className="d-none d-md-inline">Urutkan : &nbsp;</span>
                                <select 
                                    className="form-select d-inline filter-type"
                                    onChange={(e) => setFilter(e.target.value)}
                                >
                                    <option value="semua">Semua</option>
                                    <option value="popular">Terpopuler</option>
                                    <option value="latest">Terbaru</option>
                                </select>
                            </div>
                        </div>
                        <Spotlight open={openSpotlight} setOpen={setOpenSpotlight} />
                        {
                            searchTitle !== null && (
                                <div className="mt-3">Hasil pencarian dari : <strong>{searchTitle}</strong> </div>
                            )
                        }
                        <div className="row">
                            {
                                loading
                                    ? [...Array(skeletonCount)].map((item, index) => {
                                        return ((<div key={index} className="col-lg-4 my-2"><CardSkeleton /></div>))
                                    })
                                    : currentData?.length == 0 ? (
                                        <div className="text-center mt-5">
                                            <img
                                                width="60"
                                                src="/assets/image/catalog/not-found.png"
                                                className="img-fluid"
                                                alt="Not found"
                                            />
                                            <div className="text-center mt-2">Buku belum tersedia</div>
                                        </div>
                                    )
                                        : currentData?.map((book, index) => {
                                            return (
                                                <div key={index} className="col-lg-4 my-2">
                                                    <Link to={`/katalog/${book.slug}`} className="text-decoration-none text-dark">
                                                        <CardBook
                                                            image={book.image}
                                                            title={book.title}
                                                            typeBook={book.type}
                                                            level={book.level}
                                                            book={book}
                                                        />
                                                    </Link>
                                                </div>
                                            )
                                        })
                            }
                        </div>
                        <div className="mt-4">
                            <div onClick={() => scrollTop()}>
                                <Paginator
                                    pagePrevText={<FontAwesomeIcon icon={faArrowLeft} />}
                                    pageNextText={<FontAwesomeIcon icon={faArrowRight} />}
                                    totalRecords={books?.length}
                                    pageLimit={pageLimit}
                                    pageNeighbours={2}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />

                            </div>
                            {/* <button onClick={() => setLimit()} className="btn btn-primary rounded-pill">Load more</button> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="descriptionModal" tabIndex="-1" aria-labelledby="descriptionModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="descriptionModalLabel">Penjelasan Jenjang Buku</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td width={150}>Pembaca Dini A</td>
                                        <td>{message[0]}</td>
                                    </tr>
                                    <tr>
                                        <td>Pembaca Awal B1, B2, dan B3</td>
                                        <td>{message[1]}</td>
                                    </tr>
                                    <tr>
                                        <td>Pembaca Semenjana C</td>
                                        <td>{message[2]}</td>
                                    </tr>
                                    <tr>
                                        <td>Pembaca Madya D</td>
                                        <td>{message[3]}</td>
                                    </tr>
                                    <tr>
                                        <td>Pembaca Mahir E</td>
                                        <td>{message[4]}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SectionCatalog